export default __webpack_public_path__ + "static/media/fc6-logo.b051423e.png";